import $ from 'jquery'

export default {
  name: 'ajout-type',
  components: {},
  props: [],
  data () {
    return {
        loading: false,
        libelle: '',
        val_occurence: [""],
        attributs: [
            {
                "libelle":"",
                "type":"",
            }
        ],
    }
  },
  computed: {
    type_attributs() {
        return this.$store.getters['attributs']
    },
    
  },
  mounted () {
    setTimeout(() => {
        $('.p-content').fadeIn();
    }, 500);

    this.$store.dispatch("getTypeAttribut");
  },
  methods: {
    addAttribut: function () {
        this.attributs.push({ type: '',  libelle: '' });
    },

    deleteOccurence(index, id) {
        this.attributs[index].occurences.splice(id, 1)
    },

    deleteAttribut(index) {
        this.attributs.splice(index, 1)
    },

    changeType(event, index) {
        if(event.target.value == 6 || event.target.value == 7) {
            this.$set(this.attributs, index, {type: this.attributs[index].type,  libelle: this.attributs[index].libelle, occurences: []})
        } else {
            this.$set(this.attributs, index, {type: this.attributs[index].type,  libelle: this.attributs[index].libelle})
        }
    },

    addOccurence(index ){
        
        if(this.val_occurence[index] == "") {
            console.log("error")
        }
        else {
            this.attributs[index].occurences.push(this.val_occurence[index]);
            this.val_occurence[index] =''
        }
            
    },

    async submitForm() {
        console.log('tes');

        const isValid = await this.$refs.observer.validate();

        if (!isValid) {
            console.log('error')
        }
        else {
            this.loading=true;

            const data = {
                libelle:  this.libelle,
                attributs: this.attributs
            }
    
            this.$store.dispatch("putTypeArticle",data).then(
                response => {
                    if (response) {
                        this.loading=false;
                        this.$router.push({ path: `/parametres/type/${response.id}` }) 
                        location.reload()
                    } else {
                        this.loading=true;
                    }
                }
            );
        }
    }
  }
}


